import { render } from "./front-layout.vue?vue&type=template&id=bee6060e"
import script from "./front-layout.vue?vue&type=script&lang=js"
export * from "./front-layout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__